import React, { useMemo } from 'react';
import RoleDashboardTemplate from './RoleDashboardTemplate';
import { useAuth } from '../../context/AuthContext';
import { buildRoleWorkspaceModules } from '../../config/roleWorkspaceConfig';

const ProjectManagerDashboardPage = () => {
  const auth = useAuth();
  const modules = useMemo(() => buildRoleWorkspaceModules('project_manager', auth), [auth]);

  return (
    <RoleDashboardTemplate
      title="Project Manager Dashboard"
      subtitle="Project operations hub for assignments, progress, and activity history."
      modules={modules}
    />
  );
};

export default ProjectManagerDashboardPage;
